export default __webpack_public_path__ + "static/media/photo-2.d4b93a05.jpg";